import { Dialog, DialogActions, DialogContent, DialogTitle, FormGroup } from "@mui/material";
import DialogFooterWithLoading from "../../Loading/DialogFooterWithLoading";
import { useEffect, useState } from "react";
import HESPFormLabel from "../../HESPFormLabel/HESPFormLabel";
import DropdownSelector from "../../Regions/DropdownSelector";
import gql from "graphql-tag";
import { useMutation } from "react-apollo";
import { toast } from "react-toastify";
import {
    UpdateChannelDatacenterMutation,
    UpdateChannelDatacenterMutationVariables,
} from "./__generated__/UpdateChannelDatacenterMutation";
import { GET_CHANNEL_QUERY } from "../Overview/channelQueriesMutations";

export const UPDATE_CHANNEL_DATACENTER_MUTATION = gql`
    mutation UpdateChannelDatacenterMutation($input: UpdateChannelDatacenterInput!) {
        updateChannelDatacenterMutation(input: $input) {
            channelId
        }
    }
`;

interface Props {
    channelId: string;
    organizationId: string;
    open: boolean;
    onClose: () => void;
    currentDatacenterId: string;
    datacenters: { id: string; name: string }[];
}

export default function ChannelChangeDatacenterDialog({
    currentDatacenterId,
    channelId,
    datacenters,
    onClose,
    open,
    organizationId,
}: Props) {
    const [selectedId, setSelectedId] = useState<string>(currentDatacenterId);

    useEffect(() => {
        setSelectedId(currentDatacenterId);
    }, [currentDatacenterId, open]);

    const [updateDatacenter, { loading }] = useMutation<
        UpdateChannelDatacenterMutation,
        UpdateChannelDatacenterMutationVariables
    >(UPDATE_CHANNEL_DATACENTER_MUTATION);

    async function onAssign(): Promise<void> {
        try {
            await updateDatacenter({
                variables: {
                    input: {
                        channelId,
                        organizationId,
                        datacenterId: selectedId,
                    },
                },
                refetchQueries: [
                    {
                        query: GET_CHANNEL_QUERY,
                        variables: {
                            channelId,
                            organizationId,
                        },
                    },
                ],
            });
            onClose();
            toast.success("Datacenter changed");
        } catch {
            toast.error("Could not assign datacenter");
        }
    }

    return (
        <Dialog fullWidth open={open}>
            <DialogTitle>Change data center of channel</DialogTitle>
            <DialogContent>
                <FormGroup>
                    <HESPFormLabel label="Data centers" />
                    <DropdownSelector
                        items={datacenters.map((dc) => ({ key: dc.id, value: dc.name }))}
                        selectedKey={selectedId}
                        onChangeSelected={(key) => setSelectedId(key)}
                    />
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <DialogFooterWithLoading
                    isLoading={loading}
                    onCancelClick={onClose}
                    defaultText={"Assign"}
                    onActionClick={() => onAssign()}
                    loadingText={"Assigning.."}
                />
            </DialogActions>
        </Dialog>
    );
}
